import React from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import { ingInvSummaryRequest } from 'actions/inventory/summary';
import { getFormValues } from 'redux-form';
import moment from 'moment';
import styles from './ListSummaryIngredients.css';

class ListSummaryIngredients extends React.Component {
  render() {
    const { ingredients, search } = this.props;

    return (
      ingredients.length > 0 && (
        <div className={styles.wrapper}>
          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={styles.c20}>Ingredient</th>
                <th className={styles.c12}>Category</th>
                {search && search.outletIds && search.outletIds.length > 1 && (
                  <th className={styles.c12}>Outlet</th>
                )}
                <th className={`text-center ${styles.c12}`}>Beginning</th>
                <th className={`text-center ${styles.c12}`}>Purchase Order</th>
                <th className={`text-center ${styles.c12}`}>Usage</th>
                <th className={`text-center ${styles.c12}`}>Transfer</th>
                <th className={`text-center ${styles.c12}`}>Adjustment</th>
                <th className={`text-center ${styles.c12}`}>Ending</th>
                <th className={`text-center ${styles.c12}`}>Unit</th>
              </tr>
            </thead>
          </table>
          <div className={styles['table-content-wrapper']}>
            <InfiniteScroll
              pageStart={1}
              loadMore={this._onReachBottom}
              hasMore={this._hasMore()}
              useWindow={false}
              threshold={10}
              initialLoad={false}
            >
              <table className={`${styles['table-content']}`}>
                <tbody>{ingredients.map(this._renderRowIngredient)}</tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      )
    );
  }

  _renderRowIngredient = rowIng => {
    const { search } = this.props;
    return (
      <tr key={rowIng.id}>
        <td className={styles.c20}>{rowIng.ingredient_name}</td>
        <td className={`${styles.c12}`}>{rowIng.category_name}</td>
        {search && search.outletIds && search.outletIds.length > 1 && (
          <td className={styles.c12}>{rowIng.outlet_name}</td>
        )}
        <td className={`text-center ${styles.c12}`}>
          {rowIng.ingredient_summary.beginning}
        </td>
        <td className={`text-center ${styles.c12}`}>
          {rowIng.ingredient_summary.purchase_order}
        </td>
        <td className={`text-center ${styles.c12}`}>
          {rowIng.ingredient_summary.usage}
        </td>
        <td className={`text-center ${styles.c12}`}>
          {rowIng.ingredient_summary.transfer}
        </td>
        <td className={`text-center ${styles.c12}`}>
          {rowIng.ingredient_summary.adjustment}
        </td>
        <td className={`text-center ${styles.c12}`}>
          {rowIng.ingredient_summary.ending}
        </td>
        <td className={`text-center ${styles.c12}`}>
          {rowIng.ingredient_unit}
        </td>
      </tr>
    );
  };

  _hasMore = () => {
    const { currentPage, totalPage } = this.props;
    return currentPage < totalPage;
  };

  _onReachBottom = () => {
    const {
      currentPage,
      totalPage,
      dispatch,
      search: {
        date: { startDate, endDate },
        keyword,
      },
      ingredients,
    } = this.props;
    if (currentPage < totalPage) {
      dispatch(
        ingInvSummaryRequest(
          {
            page: currentPage + 1,
            start_date: moment(startDate).format('YYYY/MM/DD'),
            end_date: moment(endDate).format('YYYY/MM/DD'),
            keyword,
          },
          ingredients
        )
      );
    }
  };
}

function mapStateToProps(state) {
  const { currentPage, totalPage, ingredients } = state.inventory.summary;
  return {
    currentPage,
    totalPage,
    search: getFormValues('search')(state),
    ingredients,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListSummaryIngredients);
